import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/icons"; // icon
// 自适应
import "@/utils/viewport";

Vue.config.productionTip = false;

Vue.use(Element);

Vue.prototype.$typeValue = "dg";
// Vue.prototype.$typeValue = 'sz';

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
